export var HomeActionTypes;
(function (HomeActionTypes) {
    HomeActionTypes["FETCH_HOME_ATTEMPT"] = "FETCH_HOME_ATTEMPT";
    HomeActionTypes["FETCH_HOME_SUCCESS"] = "FETCH_HOME_SUCCESS";
    HomeActionTypes["FETCH_HOME_FAILURE"] = "FETCH_HOME_FAILURE";
})(HomeActionTypes || (HomeActionTypes = {}));
